import { Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import InputTypeSwitch from './InputTypeSwitch';

const DynamicFormFields = (props) => {
  const { fields, setFieldValue, values, touched, errors, marketoValidation } = props;
  if (!fields) return null;

  return fields.map((field, i) => {
    const pairedFields = ['firstname', 'lastname'];
    const name = field.name;
    const isOneColumn = pairedFields.indexOf(name.toLowerCase()) > -1;

    if (field.dataType === 'hidden') {
      return <Field key={field.id} type={field.dataType} name={name} />;
    }

    return (
      <InputTypeSwitch
        key={i}
        formSetFieldValue={setFieldValue}
        formValues={values}
        fieldData={field}
        name={name}
        disabled={props.submitting}
        isOneColumn={isOneColumn}
        error={touched[name] && errors[name]}
        marketoValidation={marketoValidation}
      />
    );
  });
};

DynamicFormFields.propTypes = {
  setFieldValue: PropTypes.func,
  values: PropTypes.any,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      defaultValue: PropTypes.any,
      order: PropTypes.number,
      id: PropTypes.any.isRequired,
      name: PropTypes.string.isRequired,
      label: PropTypes.string,
      isRequired: PropTypes.bool,
      maxLength: PropTypes.number,
      validationMessage: PropTypes.string,
    })
  ).isRequired,
  submitting: PropTypes.bool,
  errors: PropTypes.object,
  touched: PropTypes.object,
  marketoValidation: PropTypes.bool,
};

export default DynamicFormFields;
